import { Input, Alert } from '@drip/drip-design';
import React, { useState, useImperativeHandle, useRef } from 'react';
import { Search20 } from '@drip/drip-design-icons';
import './index.less';
import CategoryInventoryTable from '@/pages/activity-manage/merchants/detail/components/category-hp/components/category-inventory-table';
import { debounce } from 'lodash';
import AcceptHistoryModal from './components/accept-history-modal';
import changeHistory from '../inventory-change-history';

function CategoryInventoryList(props, ref) {
  const { activityId, goSelect, isOwner, refreshBlock, dataForAlert, log_sense_id } = props;
  const [inputVal, setInputVal] = useState('');

  const tableRef = useRef(null);

  useImperativeHandle(ref, () => ({
    refresh: () => {
      tableRef.current.refresh();
    },
  }));

  // 搜索框防抖
  const changeInputVal = debounce((value) => {
    setInputVal(value);
  }, 800);

  return (
    <div className="category-inventory-list">
      <div className="__header-block">
        <div className="category-inventory-list-title">
          类目维度货盘 <AcceptHistoryModal activityId={activityId} log_sense_id={log_sense_id} />
        </div>
        <Input
          style={{ width: 300 }}
          placeholder="请输入货盘名称/创建人erp/ 搜索"
          onChange={(e) => {
            changeInputVal(e.target.value);
          }}
          suffix={<Search20 style={{ color: 'rgba(0, 0, 0, 0.45)' }} />}
        />
      </div>
      {!!isOwner && <EntryOfInventoryHistory {...dataForAlert} activityId={activityId} />}
      <CategoryInventoryTable
        ref={tableRef}
        expandable={true}
        type={2}
        activityId={activityId}
        searchField={inputVal}
        goSelect={goSelect}
        isOwner={isOwner}
        refreshBlock={refreshBlock}
        log_sense_id={log_sense_id}
      />
    </div>
  );
}

function EntryOfInventoryHistory({ needConfirmInveRuleNum, activityId }) {
  if (!needConfirmInveRuleNum) return null;

  return (
    <Alert
      style={{ marginBottom: '10px' }}
      type="info"
      showIcon
      action={
        <a style={{ cursor: 'pointer' }} onClick={() => changeHistory.show({ activityId })}>
          去查看
        </a>
      }
      message={<span>{needConfirmInveRuleNum} 个类目货盘的货盘规则有更新，点击可查看货盘更新记录～</span>}
    />
  );
}

export default React.forwardRef(CategoryInventoryList);
